import styled, { css } from "styled-components";
import { getThemeFontSize, getThemeMedia, getThemeSpace } from "../helpers";
export const Container = styled.div `
	position: relative;

	margin: auto 0;

	button {
		position: relative;

		cursor: ${({ hasClick }) => (hasClick ? "pointer" : "default")};
	}

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			transition: all 300ms ease;
			border-radius: 4px;
			padding: ${getThemeSpace("8")} ${getThemeSpace("16")};

			${({ color }) => color &&
    css `
					&:hover {
						background-color: var(--surface-accent-dark);
					}
				`}
		}
	}
`;
export const AmountContainer = styled.small `
	position: absolute;
	top: 0;
	right: -12px;
	display: flex;
	justify-content: center;
	align-items: center;

	background-color: var(--semantic-warning-base);
	color: var(--text-invert);
	border-radius: 4px;
	font-size: ${getThemeFontSize("14")};
	border: 1px solid var(${({ borderColor }) => borderColor});
	height: 16px;
	width: 16px;

	transform: translate(-50%, -50%);

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			right: -16px;
		}
	}
`;
//# sourceMappingURL=styles.js.map